import React, { useState, useRef } from 'react'
import './verification.css'
import { Link, useParams, useNavigate } from 'react-router-dom'
import logo from "../../assets/Aspom-Logo.png"
import Loader from '../../components/loader/Loader'
import {verificationCode} from '../../api'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);

const Verification = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [digits, setDigits] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);
    const {id} = useParams()
    const navigate = useNavigate()

    const handleChange = (index, e) => {
        const { value } = e.target;
        if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 1) {
        const newDigits = [...digits];
        newDigits[index] = value;
        setDigits(newDigits);
        if (index < 5) {
            inputRefs.current[index + 1].focus();
        }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && index > 0) {
            const newDigits = [...digits];
            newDigits[index - 1] = '';
            setDigits(newDigits);
            inputRefs.current[index - 1].focus();
        } else if (e.key === 'Backspace' && index === 0) {
            // If backspace is pressed on the first input field and it's empty,
            // move the focus to the last input field
            inputRefs.current[5].focus();
        } else if (e.key === 'Backspace' && index === 5) {
            // If backspace is pressed on the last input field and it's empty,
            // move the focus to the previous input field and clear its value
            const newDigits = [...digits];
            newDigits[index - 1] = '';
            setDigits(newDigits);
            inputRefs.current[index - 1].focus();
        }
    };

    const handleForgotPassword = async () => {
        setIsLoading(true)
        const code = digits.join('')
        if(!code.length > 5){
            MySwal.fire({
                icon: 'warning',
                text: 'Enter all input field',
                showConfirmButton: false,
                timer: 3000
            });
        }
        try {
            const res = await verificationCode(id, code)
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    text: res?.message,
                    showConfirmButton: true,
                    confirmButtonText: 'Proceed!',
                    // timer: 3000
                }).then((result)=>{
                    if (result.isConfirmed){
                        navigate('/auth')
                    }
                })
            }else{
                MySwal.fire({
                    icon: 'error',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                text: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 3000
            });
        }
    }
  return (
    <section className='verification__page'>
        <div className="verification__container">
            <div className="verification__content-heading">
                <div className="verification__content-text">
                    <h1 className="verification__form-title">
                        Verify email
                    </h1>
                    <span className="verification__form-subtitle">
                        Enter the code sent to your email address to verify your account
                    </span>
                </div>
                <img src={logo} alt="" className="verification__content-logo" />
            </div>


            <div className="verification__form">
                <div className="verification__form-data">
                    <div className='verification__form-div'>
                        <label htmlFor="email" className='verification__form-label'>
                            Code
                        </label>
                        <div className="verification__form-field">
                            {digits.map((digit, index) => (
                                <input 
                                key={index}
                                ref={ref => (inputRefs.current[index] = ref)}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={e => handleChange(index, e)}
                                onKeyDown={e => handleKeyDown(index, e)}
                                className='verification__form-input'
                                />
                            ))}
                        </div>
                    </div>
                    
                </div>

                <Link to='/auth' className='verification__form-link'>
                    Signup
                </Link>
                {isLoading ? <Loader/> : <button
                onClick={handleForgotPassword}
                type='button'
                className='verification__form-button'>
                    Submit
                </button>}
            </div>

        </div>
    </section>
  )
}

export default Verification